import SummaryStat from './SummaryStat';

export default SummaryStat;
